/**
 * Generated bundle index. Do not edit.
 */

export {ROUTER_ERROR,ROUTER_CANCEL,ROUTER_NAVIGATION,RouterNavigationAction,RouterCancelAction,RouterErrorAction,RouterAction,routerReducer,RouterErrorPayload,RouterReducerState,RouterCancelPayload,RouterNavigationPayload,StoreRouterConnectingModule,RouterStateSerializer,DefaultRouterStateSerializer} from './public_api';



// WEBPACK FOOTER //
// ../../../modules/router-store/index.ts